module.exports = __webpack_public_path__ + "static/images/components/Nation/images/flag-all-sweden.96412065.png";


//////////////////
// WEBPACK FOOTER
// ./components/Nation/images/flag-all-sweden.png
// module id = 2619
// module chunks = 11